(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-cart-section]');
    if (!section) return;

    const rows = section.querySelectorAll('[data-line]');
    const subtotals = section.querySelectorAll('[data-cart-subtotal]');
    const status = section.querySelector('[data-cart-status]');
    const discountWrapper = section.querySelector('[data-discount]');
    const shorteningLinkKey = '_kuerzung_id';
    const shorteningServiceKey = '_kuerzung_service';
    const shorteningNoteKey = section.dataset.shorteningNoteKey || '_kuerzung_note_key';
    const shorteningNoteLabel = section.dataset.shorteningNoteLabel || '';
    const syncStorageKey = 'cart-shortening-sync';
    let syncInFlight = false;

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.Shopify.money_format);
      }
      return (cents / 100).toFixed(2);
    }

    function updateHeaderCount(count) {
      const counter = document.querySelector('.header__cart-count');
      if (!counter) return;
      counter.textContent = count;
      counter.hidden = count === 0;
    }

    function updateSubtotals(cart) {
      subtotals.forEach((node) => {
        node.textContent = formatMoney(cart.total_price);
      });
    }

    function requestCartChange(payload) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then((res) => {
        if (!res.ok) throw new Error('cart_change_failed');
        return res.json();
      });
    }

    function buildCleanProperties(item) {
      if (!item || !item.properties) return { properties: {}, changed: false };
      const properties = {};
      let changed = false;
      const noteKey = item.properties[shorteningNoteKey] || shorteningNoteLabel;

      Object.keys(item.properties).forEach((key) => {
        if (key === shorteningLinkKey || key === shorteningServiceKey || key === shorteningNoteKey) {
          changed = true;
          return;
        }
        if (noteKey && key === noteKey) {
          changed = true;
          return;
        }
        properties[key] = item.properties[key];
      });

      return { properties, changed };
    }

    function getSyncSignature(changes) {
      const normalized = changes.map((change) => {
        const keys = change.properties ? Object.keys(change.properties).sort() : [];
        return {
          id: change.id,
          quantity: change.quantity,
          keys,
        };
      });
      normalized.sort((a, b) => {
        if (a.id === b.id) return a.quantity - b.quantity;
        return a.id.localeCompare(b.id);
      });
      return JSON.stringify(normalized);
    }

    function syncShorteningPairs(cart) {
      if (!cart || !cart.items) return Promise.resolve(cart);
      if (syncInFlight) return Promise.resolve(cart);
      const mainItems = {};
      const serviceItems = {};
      const changes = [];

      cart.items.forEach((item, index) => {
        if (!item.properties) return;
        const linkId = item.properties[shorteningLinkKey];
        if (!linkId) return;
        if (item.properties[shorteningServiceKey]) {
          serviceItems[linkId] = { line: index + 1, quantity: item.quantity, item };
        } else {
          mainItems[linkId] = { line: index + 1, quantity: item.quantity, item };
        }
      });

      Object.keys(serviceItems).forEach((linkId) => {
        if (!mainItems[linkId]) {
          changes.push({
            id: serviceItems[linkId].item.key,
            quantity: 0,
          });
        }
      });

      Object.keys(mainItems).forEach((linkId) => {
        if (!serviceItems[linkId]) {
          const { properties, changed } = buildCleanProperties(mainItems[linkId].item);
          if (changed) {
            changes.push({
              id: mainItems[linkId].item.key,
              quantity: mainItems[linkId].item.quantity,
              properties,
            });
          }
        } else if (serviceItems[linkId].quantity !== mainItems[linkId].quantity) {
          changes.push({
            id: serviceItems[linkId].item.key,
            quantity: mainItems[linkId].quantity,
          });
        }
      });

      if (!changes.length) {
        sessionStorage.removeItem(syncStorageKey);
        return Promise.resolve(cart);
      }

      const signature = getSyncSignature(changes);
      if (sessionStorage.getItem(syncStorageKey) === signature) {
        if (status) status.textContent = section.dataset.statusError;
        return Promise.resolve(cart);
      }

      sessionStorage.setItem(syncStorageKey, signature);
      if (status) status.textContent = section.dataset.statusShorteningSync;

      syncInFlight = true;
      const sequence = changes.reduce((promise, change) => {
        return promise.then(() => requestCartChange(change));
      }, Promise.resolve());

      return sequence
        .then((updatedCart) => {
          window.location.reload();
          return updatedCart;
        })
        .catch(() => {
          if (status) status.textContent = section.dataset.statusError;
          return cart;
        })
        .finally(() => {
          syncInFlight = false;
        });
    }

    rows.forEach((row) => {
      const line = parseInt(row.dataset.line, 10);
      const lineItemKey = row.dataset.lineItemKey;
      const quantityInput = row.querySelector('[data-quantity-input]');
      const removeButton = row.querySelector('[data-remove]');
      const lineTotal = row.querySelector('[data-line-total]');

      if (quantityInput) {
        quantityInput.addEventListener('change', () => {
          const quantity = parseInt(quantityInput.value || '0', 10);
          status.textContent = '';
          const payload = lineItemKey ? { id: lineItemKey, quantity } : { line, quantity };
          requestCartChange(payload).then((cart) => {
            const item = lineItemKey
              ? cart.items.find((cartItem) => cartItem.key === lineItemKey)
              : cart.items[line - 1];
            if (!item || quantity === 0) {
              row.remove();
              if (!section.querySelector('[data-line]')) {
                window.location.reload();
                return;
              }
            }

            if (item && lineTotal) {
              lineTotal.textContent = formatMoney(item.final_line_price);
            }

            updateSubtotals(cart);
            updateHeaderCount(cart.item_count);
            status.textContent = section.dataset.statusUpdated;
            syncShorteningPairs(cart);
          }).catch(() => {
            status.textContent = section.dataset.statusError;
          });
        });
      }

      if (removeButton) {
        removeButton.addEventListener('click', () => {
          status.textContent = '';
          const payload = lineItemKey ? { id: lineItemKey, quantity: 0 } : { line, quantity: 0 };
          requestCartChange(payload).then((cart) => {
            row.remove();
            updateSubtotals(cart);
            updateHeaderCount(cart.item_count);
            if (!section.querySelector('[data-line]')) {
              window.location.reload();
              return;
            }
            status.textContent = section.dataset.statusRemoved;
            syncShorteningPairs(cart);
          }).catch(() => {
            status.textContent = section.dataset.statusError;
          });
        });
      }
    });

    if (discountWrapper) {
      const discountInput = discountWrapper.querySelector('[data-discount-input]');
      const discountStatus = discountWrapper.querySelector('[data-discount-status]');
      const applyButton = discountWrapper.querySelector('[data-apply-discount]');
      const removeButtons = discountWrapper.querySelectorAll('[data-discount-remove]');
      const messageApplied = discountWrapper.dataset.textApplied;
      const messageError = discountWrapper.dataset.textError;
      const messageEmpty = discountWrapper.dataset.textEmpty;
      const messageCleared = discountWrapper.dataset.textCleared;

      function setDiscountStatus(text) {
        if (discountStatus) {
          discountStatus.textContent = text;
        }
      }

      function applyDiscount() {
        const code = discountInput && discountInput.value ? discountInput.value.trim() : '';
        if (!code) {
          setDiscountStatus(messageEmpty);
          if (discountInput) discountInput.focus();
          return;
        }
        setDiscountStatus(messageApplied);
        fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`).then(() => {
          window.location.reload();
        }).catch(() => {
          setDiscountStatus(messageError);
        });
      }

      if (applyButton) {
        applyButton.addEventListener('click', applyDiscount);
      }

      if (discountInput) {
        discountInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            applyDiscount();
          }
        });
      }

      removeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          setDiscountStatus(messageCleared);
          fetch('/discounts/clear?redirect=/cart').then(() => {
            try {
              window.localStorage.removeItem('abayastore:applied-discount-code');
            } catch (err) {}
            window.location.reload();
          }).catch(() => {
            setDiscountStatus(messageError);
          });
        });
      });
    }

    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => syncShorteningPairs(cart));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCategoryBar = (section) => {
      if (!section || section.dataset.categoryBarInit === 'true') return;
      section.dataset.categoryBarInit = 'true';

      const track = section.querySelector('[data-scroll-track]');
      const wrap = section.querySelector('[data-scroll-wrap]');
      const arrows = section.querySelector('[data-arrows]');
      const prevBtn = section.querySelector('[data-prev]');
      const nextBtn = section.querySelector('[data-next]');

      if (!track || !wrap) return;

      const getStep = () => {
        const item = track.querySelector('.category-bar__item');
        if (!item) return Math.max(track.clientWidth * 0.55, 140);
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return item.getBoundingClientRect().width + gap;
      };

      const updateState = () => {
        const items = Array.from(track.querySelectorAll('.category-bar__item'));
        if (!items.length) return;

        const trackStyles = window.getComputedStyle(track);
        const paddingLeft = parseFloat(trackStyles.paddingLeft) || 0;
        const paddingRight = parseFloat(trackStyles.paddingRight) || 0;
        const available = Math.max(track.clientWidth - paddingLeft - paddingRight, 0);
        const isDesktop = window.matchMedia('(min-width: 900px)').matches;

        const circle =
          items[0].querySelector('.category-bar__media')?.getBoundingClientRect().width ||
          parseFloat(getComputedStyle(section).getPropertyValue('--category-circle-size')) ||
          96;
        const itemWidth = isDesktop ? Math.max(circle, 120) : circle;
        const gap = isDesktop ? 28 : 16;
        const needed = items.length * itemWidth + Math.max(items.length - 1, 0) * gap;
        const isOverflowing = needed > available + 1;

        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        const atStart = track.scrollLeft <= 2;
        const atEnd = !isOverflowing || track.scrollLeft >= maxScroll - 2;

        track.classList.toggle('is-fitted', !isOverflowing);
        track.classList.toggle('is-scrollable', isOverflowing);
        wrap.classList.toggle('is-overflowing-start', isOverflowing && !atStart);
        wrap.classList.toggle('is-overflowing-end', isOverflowing && !atEnd);

        if (arrows) {
          if (isOverflowing) {
            arrows.removeAttribute('hidden');
          } else {
            arrows.setAttribute('hidden', '');
          }
        }

        if (prevBtn) prevBtn.disabled = !isOverflowing || atStart;
        if (nextBtn) nextBtn.disabled = !isOverflowing || atEnd;
      };

      const scrollByStep = (direction) => {
        track.scrollBy({ left: direction * getStep(), behavior: 'smooth' });
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => scrollByStep(-1));
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => scrollByStep(1));
      }

      let pointerStartX = 0;
      let pointerStartScroll = 0;
      let isDragging = false;
      let didDrag = false;

      const onPointerDown = (event) => {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;
        if (!track.classList.contains('is-scrollable')) return;
        isDragging = true;
        didDrag = false;
        pointerStartX = event.clientX;
        pointerStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture?.(event.pointerId);
      };

      const onPointerMove = (event) => {
        if (!isDragging) return;
        const delta = event.clientX - pointerStartX;
        if (Math.abs(delta) > 3) didDrag = true;
        track.scrollLeft = pointerStartScroll - delta;
      };

      const onPointerUp = (event) => {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        track.releasePointerCapture?.(event.pointerId);
      };

      track.addEventListener('pointerdown', onPointerDown);
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', onPointerUp);
      track.addEventListener('pointercancel', onPointerUp);
      track.addEventListener(
        'click',
        (event) => {
          if (!didDrag) return;
          event.preventDefault();
          event.stopPropagation();
          didDrag = false;
        },
        true
      );

      track.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', () => requestAnimationFrame(updateState));

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(() => requestAnimationFrame(updateState));
        observer.observe(track);
        observer.observe(wrap);
      }

      requestAnimationFrame(updateState);
    };

    const boot = () => {
      document.querySelectorAll('[data-category-bar]').forEach(initCategoryBar);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-category-bar]') || event.target.closest('[data-category-bar]');
      if (section) {
        section.dataset.categoryBarInit = 'false';
        initCategoryBar(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const details = document.querySelectorAll('details.collection__sort');
    details.forEach((detail) => {
      if (detail.hasAttribute('open') && !detail.contains(event.target)) {
        detail.removeAttribute('open');
      }
    });
  });

  const collectionSection = document.querySelector('.collection');
  if (collectionSection) {
    const params = new URLSearchParams(window.location.search);
    const showSoldOut = params.get('show_sold_out') === '1';
    const hideSoldOut = params.get('filter.v.availability') === '1';
    const collectionUrl = collectionSection.dataset.collectionUrl || window.location.pathname;
    const currentSort = collectionSection.dataset.collectionSort || params.get('sort_by') || '';

    const buildCollectionUrl = (options = {}) => {
      const next = new URL(collectionUrl, window.location.origin);
      if (options.sortBy || currentSort) {
        next.searchParams.set('sort_by', options.sortBy || currentSort);
      }
      if (options.showSoldOut) {
        next.searchParams.set('show_sold_out', '1');
        next.searchParams.delete('filter.v.availability');
      } else {
        next.searchParams.set('filter.v.availability', '1');
        next.searchParams.delete('show_sold_out');
      }
      return next.toString();
    };

    if (hideSoldOut) {
      collectionSection.classList.add('collection--hide-sold-out');
    } else if (showSoldOut) {
      collectionSection.classList.remove('collection--hide-sold-out');
    }

    const soldOutToggle = collectionSection.querySelector('[data-sold-out-toggle]');
    if (soldOutToggle) {
      soldOutToggle.checked = showSoldOut;
      soldOutToggle.addEventListener('change', () => {
        window.location.assign(buildCollectionUrl({ showSoldOut: soldOutToggle.checked }));
      });
    }

    collectionSection.querySelectorAll('.collection__sort-option[data-sort-value]').forEach((link) => {
      const sortValue = link.getAttribute('data-sort-value');
      if (!sortValue) return;
      link.setAttribute('href', buildCollectionUrl({
        sortBy: sortValue,
        showSoldOut: showSoldOut,
      }));
    });

    if (showSoldOut || hideSoldOut) {
      collectionSection.querySelectorAll('.pagination a[href]').forEach((link) => {
        try {
          const url = new URL(link.href, window.location.origin);
          if (showSoldOut) {
            url.searchParams.set('show_sold_out', '1');
            url.searchParams.delete('filter.v.availability');
          } else {
            url.searchParams.set('filter.v.availability', '1');
            url.searchParams.delete('show_sold_out');
          }
          link.href = url.toString();
        } catch (error) {
          // Ignore invalid pagination URLs
        }
      });
    }

    const revealItems = collectionSection.querySelectorAll('[data-collection-item]');
    if (revealItems.length > 0) {
      collectionSection.classList.add('is-ready');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      } else if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.2 });
        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creator-application"] && !Shopify.designMode) return;
  try {
    
  class CreatorApplicationForm {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('form');
      this.panels = Array.from(root.querySelectorAll('[data-step-panel]'));
      this.indicators = Array.from(root.querySelectorAll('[data-step-indicator]'));
      this.currentStep = 0;

      if (!this.form || this.panels.length === 0) return;

      this.root.classList.add('is-enhanced');
      this.bindEvents();
      this.showStep(0, false);
    }

    bindEvents() {
      this.root.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const nextButton = target?.closest('[data-step-next]');
        const prevButton = target?.closest('[data-step-prev]');

        if (nextButton) {
          this.goNext();
        }

        if (prevButton) {
          this.showStep(this.currentStep - 1);
        }
      });
    }

    goNext() {
      if (!this.validatePanel(this.panels[this.currentStep])) return;
      this.showStep(this.currentStep + 1);
    }

    validatePanel(panel) {
      const fields = Array.from(panel.querySelectorAll('input, select, textarea'));
      const invalidField = fields.find((field) => !field.checkValidity());

      if (invalidField) {
        invalidField.reportValidity();
        invalidField.focus({ preventScroll: true });
        return false;
      }

      return true;
    }

    showStep(index, shouldFocus = true) {
      const nextIndex = Math.max(0, Math.min(index, this.panels.length - 1));
      this.currentStep = nextIndex;

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== nextIndex;
      });

      this.indicators.forEach((indicator, indicatorIndex) => {
        const isActive = indicatorIndex === nextIndex;
        indicator.classList.toggle('is-active', isActive);
        if (isActive) {
          indicator.setAttribute('aria-current', 'step');
        } else {
          indicator.removeAttribute('aria-current');
        }
      });

      if (shouldFocus) {
        const title = this.panels[nextIndex].querySelector('.creator-application__step-title');
        if (title) {
          title.setAttribute('tabindex', '-1');
          title.focus({ preventScroll: true });
        }
      }
    }
  }

  document.querySelectorAll('[data-creator-application]').forEach((root) => {
    new CreatorApplicationForm(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq').forEach((section) => {
    section.querySelectorAll('[data-faq-item] > summary').forEach((summary) => {
      summary.addEventListener('click', (event) => {
        const details = summary.parentElement
        if (!details || !document.startViewTransition) {
          return
        }
        event.preventDefault()
        document.startViewTransition(() => {
          details.open = !details.open
        })
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('.featured-products');
    if (!section) return;

    const items = section.querySelectorAll('.featured-products__item');
    if (!items.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, index * 80);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });

    items.forEach((item) => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(30px)';
      item.style.transition = 'opacity 0.6s cubic-bezier(0.23, 1, 0.32, 1), transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)';
      observer.observe(item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-deals"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-flash-deals-end]');
    if (!section) return;

    const endTime = new Date(section.dataset.flashDealsEnd).getTime();
    const hoursEl = section.querySelector('[data-timer-hours]');
    const minutesEl = section.querySelector('[data-timer-minutes]');
    const secondsEl = section.querySelector('[data-timer-seconds]');

    if (!hoursEl || !minutesEl || !secondsEl) return;

    function updateTimer() {
      const now = Date.now();
      const diff = Math.max(0, endTime - now);

      if (diff === 0) {
        section.classList.add('flash-deals--expired');
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');

      if (hours < 1) {
        section.classList.add('flash-deals--urgent');
      }

      requestAnimationFrame(updateTimer);
    }

    updateTimer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const toggle = header.querySelector('.header__menu-toggle');
    const drawer = header.querySelector('#MobileDrawer');
    const backdrop = drawer.querySelector('.mobile-drawer__backdrop');
    const cartDrawerOpener = header.querySelector('[data-cart-drawer-opener]');

    const slider = drawer.querySelector('.mobile-drawer__slider');
    const subTriggers = drawer.querySelectorAll('[data-target-submenu]');
    const backBtns = drawer.querySelectorAll('[data-action="back"]');
    const submenus = drawer.querySelectorAll('.mobile-drawer__submenu-container');

    // Cart count update function
    function updateCartDisplay(count) {
      const desktopCount = header.querySelector('.header__cart-count-desktop');
      const mobileCount = header.querySelector('[data-cart-mobile-count]');
      const cartButton = header.querySelector('[data-cart-drawer-opener]');

      if (desktopCount) {
        desktopCount.textContent = `(${count})`;
        if (count > 0) {
          desktopCount.classList.remove('hidden');
        } else {
          desktopCount.classList.add('hidden');
        }
      }

      if (mobileCount) {
        mobileCount.textContent = count;
        if (count > 0) {
          mobileCount.removeAttribute('hidden');
        } else {
          mobileCount.setAttribute('hidden', '');
        }
      }
    }

    // Listen for cart updates
    document.addEventListener('dispatch:cart-drawer:refresh', (e) => {
      const { cart } = e.detail;
      if (cart) {
        updateCartDisplay(cart.item_count);
      }
    });

    function openDrawer() {
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      header.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      header.classList.remove('menu-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');

      setTimeout(() => {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
          resetMenu();
        }
      }, 400);
    }

    function toggleDrawer() {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closeDrawer();
      } else {
        openDrawer();
      }
    }

    function resetMenu() {
      if (slider) slider.style.transform = 'translateX(0)';
      submenus.forEach((sub) => (sub.hidden = true));
    }

    function openSubmenu(submenuId) {
      const targetSub = document.getElementById(submenuId);
      if (targetSub) {
        submenus.forEach((sub) => (sub.hidden = true));
        targetSub.hidden = false;
        if (slider) slider.style.transform = 'translateX(-100%)';
      }
    }

    function closeSubmenu() {
      if (slider) slider.style.transform = 'translateX(0)';
    }

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleDrawer();
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }

    subTriggers.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.targetSubmenu;
        openSubmenu(targetId);
      });
    });

    backBtns.forEach((btn) => {
      btn.addEventListener('click', closeSubmenu);
    });

    if (cartDrawerOpener) {
      cartDrawerOpener.addEventListener('click', (e) => {
        e.preventDefault();
        if (header.classList.contains('menu-open')) {
          closeDrawer();
        }

        document.dispatchEvent(
          new CustomEvent('dispatch:cart-drawer:open', {
            detail: { opener: cartDrawerOpener },
          })
        );
        cartDrawerOpener.setAttribute('aria-expanded', 'true');
      });

      document.addEventListener('on:cart-drawer:after-close', () => {
        if (cartDrawerOpener) {
          cartDrawerOpener.setAttribute('aria-expanded', 'false');
          cartDrawerOpener.focus();
        }
      });
    }

    function setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }

    const transparentSetting = header.dataset.transparent;
    let transparentEnabled = false;
    if (transparentSetting === 'true') {
      transparentEnabled = true;
    }

    function updateHeaderState() {
      if (header.classList.contains('menu-open')) return;

      if (transparentEnabled) {
        if (window.scrollY > 10) {
          header.classList.add('header--scrolled');
          header.classList.remove('header--transparent');
        } else {
          header.classList.remove('header--scrolled');
          header.classList.add('header--transparent');
        }
      } else {
        header.classList.add('header--scrolled');
        header.classList.remove('header--transparent');
      }
    }

    setHeaderHeight();
    updateHeaderState();
    window.addEventListener('resize', setHeaderHeight);
    window.addEventListener('scroll', updateHeaderState, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-product-section]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const productData = section.querySelector('[type="application/json"][data-product-json]');
      const variantMediaMapData = section.querySelector('[type="application/json"][data-variant-media-map]');
      const product = productData ? JSON.parse(productData.textContent) : {};
      const variantMediaMap = variantMediaMapData ? JSON.parse(variantMediaMapData.textContent) : {};

      const formWrapper = section.querySelector('.product__form-wrapper');
      const form = formWrapper ? formWrapper.querySelector('form') : null;
      const variantInput = section.querySelector('[data-product-variant-id]');
      const priceContainer = section.querySelector('[data-product-price]');
      const availability = section.querySelector('[data-product-availability]');
      const addButton = section.querySelector('[data-add-to-cart]');
      const stickyBar = section.querySelector('[data-sticky-cart]');
      const stickyButton = stickyBar ? stickyBar.querySelector('[data-sticky-add-to-cart]') : null;
      const stickyLabel = stickyBar ? stickyBar.querySelector('[data-sticky-add-to-cart-label]') : null;
      const stickyMedia = window.matchMedia('(max-width: 899px)');
      const status = section.querySelector('[data-product-status]');
      const mediaMain = section.querySelector('[data-media-main]');
      const mediaMainWrap = section.querySelector('[data-media-main-wrap]');
      const mediaItems = section.querySelectorAll('[data-media-item]');
      const mediaThumbs = section.querySelectorAll('[data-media-thumb]');
      const mediaIndicator = section.querySelector('[data-media-indicator]');
      const shorteningWrapper = section.querySelector('[data-shortening]');
      const shorteningLengthInput = shorteningWrapper ? shorteningWrapper.querySelector('[data-shortening-length]') : null;
      const shorteningToggle = shorteningWrapper
        ? shorteningWrapper.querySelector('[data-shortening-toggle]')
        : null;
      const shorteningBody = shorteningWrapper
        ? shorteningWrapper.querySelector('[data-shortening-body]')
        : null;
      const shorteningServiceVariantId = shorteningWrapper
        ? parseInt(shorteningWrapper.dataset.serviceVariantId, 10)
        : null;
      const shorteningNoteLabel = shorteningWrapper ? shorteningWrapper.dataset.shorteningNoteLabel : '';
      const shorteningNoteTemplate = shorteningWrapper ? shorteningWrapper.dataset.shorteningNoteTemplate : '';
      const shorteningLinkKey = shorteningWrapper ? shorteningWrapper.dataset.shorteningLinkKey : '_kuerzung_id';
      const shorteningServiceKey = shorteningWrapper ? shorteningWrapper.dataset.shorteningServiceKey : '_kuerzung_service';
      const shorteningNoteKey = shorteningWrapper ? shorteningWrapper.dataset.shorteningNoteKey : '_kuerzung_note_key';
      const shorteningError = shorteningWrapper ? shorteningWrapper.dataset.shorteningError : '';
      const shorteningUnit = shorteningWrapper ? shorteningWrapper.dataset.shorteningUnit : '';
      const discountNotice = section.querySelector('[data-discount-notice]');

      const dialog = section.querySelector('[data-product-modal]');
      const modalItems = dialog ? dialog.querySelectorAll('[data-modal-media-item]') : [];
      const modalThumbs = dialog ? dialog.querySelectorAll('[data-modal-thumb]') : [];
      const modalViewer = dialog ? dialog.querySelector('[data-modal-viewer]') : null;
      const modalClose = dialog ? dialog.querySelector('[data-modal-close]') : null;

      const selectElements = section.querySelectorAll('[data-option-select]');
      const swatchButtons = section.querySelectorAll('[data-option-swatch]');
      const optionButtons = section.querySelectorAll('[data-option-button]');
      const optionValueDisplays = section.querySelectorAll('[data-option-value-display]');
      const scrollHintContainers = section.querySelectorAll('.product__variant-swatches, .product__option-buttons');

      const zoomEnabled = section.dataset.zoomEnabled === 'true';
      const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

      if (stickyBar && stickyBar.parentElement !== document.body) {
        document.body.appendChild(stickyBar);
      }

      const initialVariant = product.variants?.find((variant) => String(variant.id) === variantInput?.value);
      let selectedOptions = initialVariant
        ? [...initialVariant.options]
        : Array.from(selectElements, (select) => select.value);

      let lastFocusedElement = null;
      let modalZoomed = false;
      let swipeStartX = 0;
      let swipeStartY = 0;
      let swipeActive = false;
      let swipeBlockedClick = false;
      let swipeAxis = null;
      let modalTouchScale = 1;
      let modalTouchTranslateX = 0;
      let modalTouchTranslateY = 0;
      let modalTouchStartDistance = 0;
      let modalTouchStartScale = 1;
      let modalTouchStartX = 0;
      let modalTouchStartY = 0;
      let modalTouchStartTranslateX = 0;
      let modalTouchStartTranslateY = 0;
      let modalPinchActive = false;
      let modalPanActive = false;
      let productDiscountApplied = false;
      const productDiscountCode = discountNotice ? discountNotice.dataset.discountCode || '' : '';
      const productDiscountPercent = discountNotice ? parseInt(discountNotice.dataset.discountPercent, 10) || 0 : 0;
      const productDiscountStorageKey = 'abayastore:applied-discount-code';
      const priceCurrentLabel = section.dataset.priceCurrentText || '';
      const priceCompareLabel = section.dataset.priceCompareText || '';
      const priceUnitLabel = section.dataset.priceUnitText || '';
      const defaultMoneyPlaceholder = '{' + '{amount_with_comma_separator}' + '}';
      const moneyFormat = section.dataset.moneyFormat || '\u20AC' + defaultMoneyPlaceholder;

      function formatMoney(cents) {
        if (window.Shopify && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, window.Shopify.money_format || moneyFormat);
        }

        const formatPattern = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
        const formatType = formatPattern ? formatPattern[1] : 'amount_with_comma_separator';
        const placeholder = formatPattern ? formatPattern[0] : defaultMoneyPlaceholder;

        function formatWithDelimiters(number, precision, thousands, decimal) {
          const value = (number / 100).toFixed(precision);
          const parts = value.split('.');
          const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          const centsValue = parts[1] ? decimal + parts[1] : '';
          return dollars + centsValue;
        }

        let value = '';
        switch (formatType) {
          case 'amount':
            value = formatWithDelimiters(cents, 2, ',', '.');
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_comma_separator':
          default:
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        return moneyFormat.replace(placeholder, value);
      }

      function normalizeDiscountCode(code) {
        return code ? code.trim().toLowerCase() : '';
      }

      function getStoredDiscountCode() {
        try {
          return window.localStorage.getItem(productDiscountStorageKey) || '';
        } catch (err) {
          return '';
        }
      }

      function setStoredDiscountCode(code) {
        try {
          window.localStorage.setItem(productDiscountStorageKey, code);
        } catch (err) {}
      }

      function clearStoredDiscountCode() {
        try {
          window.localStorage.removeItem(productDiscountStorageKey);
        } catch (err) {}
      }

      function isCurrentDiscountStored() {
        return normalizeDiscountCode(getStoredDiscountCode()) === normalizeDiscountCode(productDiscountCode);
      }

      function cartHasCurrentDiscount(cart) {
        if (!cart || !productDiscountCode) return false;
        const targetCode = normalizeDiscountCode(productDiscountCode);
        const discountSources = [
          cart.discount_applications,
          cart.cart_level_discount_applications,
          cart.discount_codes
        ];

        return discountSources.some((source) => {
          if (!Array.isArray(source)) return false;
          return source.some((discount) => {
            if (discount.applicable === false) return false;
            const title = normalizeDiscountCode(discount.title);
            const code = normalizeDiscountCode(discount.code);
            return title === targetCode || code === targetCode;
          });
        });
      }

      function cartHasAnyDiscount(cart) {
        if (!cart) return false;
        const discountSources = [
          cart.discount_applications,
          cart.cart_level_discount_applications,
          cart.discount_codes
        ];

        return discountSources.some((source) => {
          if (!Array.isArray(source)) return false;
          return source.some((discount) => discount.applicable !== false);
        });
      }

      function applyProductDiscountState() {
        if (!discountNotice || !productDiscountCode || !productDiscountPercent) return;
        productDiscountApplied = true;
        discountNotice.hidden = true;
        updatePrice(getSelectedVariant());
      }

      function clearProductDiscountState() {
        if (!discountNotice) return;
        productDiscountApplied = false;
        clearStoredDiscountCode();
        discountNotice.hidden = false;
        updatePrice(getSelectedVariant());
      }

      function updatePrice(variant) {
        if (!variant || !priceContainer) return;
        let currentPrice = variant.price;
        let comparePrice = variant.compare_at_price || 0;

        if (productDiscountApplied && productDiscountPercent > 0) {
          comparePrice = variant.price;
          currentPrice = Math.max(0, Math.round(variant.price * (100 - productDiscountPercent) / 100));
        }

        const onSale = comparePrice > currentPrice && currentPrice > 0;
        const priceClasses = `price${onSale ? ' is-sale' : ''}`;
        const currentClasses = `price__current${onSale ? ' price__current--sale' : ''}`;
        const currentLabel = priceCurrentLabel ? ` aria-label="${priceCurrentLabel}"` : '';
        const compareLabel = priceCompareLabel ? ` aria-label="${priceCompareLabel}"` : '';
        const unitLabel = priceUnitLabel ? ` aria-label="${priceUnitLabel}"` : '';
        let priceHtml = `<div class="${priceClasses}" data-price><span class="${currentClasses}"${currentLabel}>${formatMoney(currentPrice)}</span>`;

        if (onSale) {
          priceHtml += `<span class="price__compare"${compareLabel}>${formatMoney(comparePrice)}</span>`;
        }

        if (variant.unit_price && variant.unit_price_measurement) {
          const measurement = variant.unit_price_measurement;
          priceHtml += `<div class="price__unit"${unitLabel}>${formatMoney(variant.unit_price)} / ${measurement.reference_value}${measurement.reference_unit}</div>`;
        }

        priceHtml += '</div>';
        priceContainer.innerHTML = priceHtml;
      }

      function updateAvailability(variant) {
        if (!availability || !variant) return;

        if (variant.available) {
          availability.innerHTML = `<span class="status-dot status-dot--success"></span> ${section.dataset.availableText}`;
          addButton.disabled = false;
          addButton.classList.remove('is-disabled');
          addButton.querySelector('span').textContent = section.dataset.addToCartText;
        } else {
          availability.innerHTML = `<span class="status-dot status-dot--error"></span> ${section.dataset.unavailableText}`;
          addButton.disabled = true;
          addButton.classList.add('is-disabled');
          addButton.querySelector('span').textContent = section.dataset.unavailableText;
        }
      }

      function syncStickyButton() {
        if (!stickyButton || !addButton) return;
        stickyButton.disabled = addButton.disabled;
        stickyButton.classList.toggle('is-disabled', addButton.classList.contains('is-disabled'));
        stickyButton.classList.toggle('is-loading', addButton.classList.contains('is-loading'));
        const addLabel = addButton.querySelector('[data-add-to-cart-label]');
        if (addLabel && stickyLabel) {
          stickyLabel.textContent = addLabel.textContent;
        }
      }

      function updateStickyVisibility() {
        if (!stickyBar || !addButton) return;
        if (!stickyMedia.matches) {
          stickyBar.classList.add('is-hidden');
          return;
        }
        const rect = addButton.getBoundingClientRect();
        const shouldShow = rect.top > window.innerHeight;
        stickyBar.classList.toggle('is-hidden', !shouldShow);
      }

      function updateShorteningUI() {
        if (!shorteningWrapper || !shorteningToggle || !shorteningBody) return;
        const isEnabled = shorteningToggle.getAttribute('aria-checked') === 'true';
        shorteningToggle.setAttribute('aria-expanded', String(isEnabled));
        shorteningBody.hidden = !isEnabled;
        if (shorteningLengthInput) {
          shorteningLengthInput.disabled = !isEnabled;
          shorteningLengthInput.required = false;
          if (!isEnabled) {
            shorteningLengthInput.setAttribute('aria-invalid', 'false');
          }
        }
      }

      function getVariantMediaIds(variant) {
        if (!variant) return [];
        const mapping = variantMediaMap[variant.id];
        if (mapping && mapping.media_ids && mapping.media_ids.length > 0) {
          return mapping.media_ids;
        }
        if (variant.featured_media) {
          return [variant.featured_media.id];
        }
        return product.media ? product.media.map((m) => m.id) : [];
      }

      function getActiveMediaId() {
        const active = mediaMain ? mediaMain.querySelector('.product__media-item.is-active') : null;
        if (!active) return null;
        const id = parseInt(active.dataset.mediaId, 10);
        return Number.isFinite(id) ? id : null;
      }

      function getVisibleMediaItems() {
        return Array.from(mediaItems).filter((item) => !item.classList.contains('is-hidden'));
      }

      function updateMediaIndicator() {
        if (!mediaIndicator) return;
        const visibleItems = getVisibleMediaItems();
        const activeId = getActiveMediaId();
        const activeIndex = visibleItems.findIndex((item) => parseInt(item.dataset.mediaId, 10) === activeId);
        if (visibleItems.length <= 1 || activeIndex === -1) {
          mediaIndicator.hidden = true;
          mediaIndicator.textContent = '';
          return;
        }
        mediaIndicator.hidden = false;
        mediaIndicator.textContent = `${activeIndex + 1}/${visibleItems.length}`;
      }

      function updateScrollHint(container) {
        if (!container) return;
        const maxScroll = container.scrollWidth - container.clientWidth;
        const canScroll = maxScroll > 2;
        const atStart = container.scrollLeft <= 1;
        const atEnd = container.scrollLeft >= maxScroll - 1;
        container.classList.toggle('is-scrollable', canScroll);
        container.classList.toggle('is-scroll-start', !canScroll || atStart);
        container.classList.toggle('is-scroll-end', !canScroll || atEnd);
      }

      function updateAllScrollHints() {
        scrollHintContainers.forEach((container) => updateScrollHint(container));
      }

      if (stickyButton && addButton) {
        syncStickyButton();
        const stickyStateObserver = new MutationObserver(() => syncStickyButton());
        stickyStateObserver.observe(addButton, {
          attributes: true,
          attributeFilter: ['class', 'disabled'],
          childList: true,
          subtree: true,
          characterData: true
        });
        stickyButton.addEventListener('click', () => {
          addButton.click();
        });
      }

      if (stickyBar && addButton) {
        let stickyTicking = false;
        const scheduleStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          requestAnimationFrame(() => {
            updateStickyVisibility();
            stickyTicking = false;
          });
        };

        updateStickyVisibility();
        window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
        window.addEventListener('resize', scheduleStickyUpdate);
        stickyMedia.addEventListener('change', updateStickyVisibility);
      }

      function moveMedia(direction) {
        const visibleItems = getVisibleMediaItems();
        if (visibleItems.length < 2) return;
        const activeId = getActiveMediaId();
        const activeIndex = visibleItems.findIndex((item) => parseInt(item.dataset.mediaId, 10) === activeId);
        if (activeIndex === -1) return;
        const nextIndex = activeIndex + direction;
        if (nextIndex < 0 || nextIndex >= visibleItems.length) return;
        const nextId = parseInt(visibleItems[nextIndex].dataset.mediaId, 10);
        if (Number.isFinite(nextId)) setActiveMedia(nextId, direction);
      }

      function getActiveModalImage() {
        if (!dialog) return null;
        const activeItem = dialog.querySelector('.product-modal__media-item.is-active');
        if (!activeItem) return null;
        return activeItem.querySelector('img.product-modal__media-asset');
      }

      function applyModalTouchTransform() {
        const img = getActiveModalImage();
        if (!img) return;
        if (modalTouchScale === 1 && modalTouchTranslateX === 0 && modalTouchTranslateY === 0) {
          img.style.transform = '';
          img.style.transformOrigin = '';
          return;
        }
        img.style.transform = `translate(${modalTouchTranslateX}px, ${modalTouchTranslateY}px) scale(${modalTouchScale})`;
      }

      function resetModalTouchZoom() {
        modalTouchScale = 1;
        modalTouchTranslateX = 0;
        modalTouchTranslateY = 0;
        modalPinchActive = false;
        modalPanActive = false;
        applyModalTouchTransform();
      }

      function getTouchDistance(touches) {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.hypot(dx, dy);
      }

      function setActiveMedia(mediaId, direction = 0) {
        if (!mediaMain) return;

        if (direction === 1) {
          mediaMain.style.setProperty('--slide-from', '100%');
        } else if (direction === -1) {
          mediaMain.style.setProperty('--slide-from', '-100%');
        } else {
          mediaMain.style.setProperty('--slide-from', '0%');
        }

        let targetItem = mediaMain.querySelector(`[data-media-id="${mediaId}"]`);
        if (!targetItem || targetItem.classList.contains('is-hidden')) {
          targetItem = mediaMain.querySelector('[data-media-item]:not(.is-hidden)');
        }
        if (!targetItem) return;

        mediaItems.forEach((node) => {
          if (!node.classList.contains('is-hidden')) node.classList.remove('is-active');
        });
        targetItem.classList.add('is-active');

        mediaThumbs.forEach((t) => t.classList.remove('is-active'));
        const targetThumb = section.querySelector(`[data-media-thumb][data-media-id="${targetItem.dataset.mediaId}"]`);
        if (targetThumb && !targetThumb.classList.contains('is-hidden')) {
          targetThumb.classList.add('is-active');
        }

        const img = targetItem.querySelector('img');
        if (img) {
          img.loading = 'eager';
          img.decoding = 'async';
          img.fetchPriority = 'high';
          if (typeof img.decode === 'function') {
            img.decode().catch(() => {});
          }
          const mediaIdNum = parseInt(targetItem.dataset.mediaId, 10);
          const mediaInfo = product.media ? product.media.find((m) => m.id === mediaIdNum) : null;
          if (mediaInfo && mediaInfo.width && mediaInfo.height) {
            const ratio = mediaInfo.width / mediaInfo.height;
            if (ratio && ratio > 0) {
              mediaMain.style.setProperty('--product-media-ratio', ratio);
            }
          }
        }
        updateMediaIndicator();
      }

      function loadModalImage(img) {
        if (!img || img.src) return;
        const dataSrc = img.dataset.src;
        if (dataSrc) {
          img.src = dataSrc;
          img.removeAttribute('data-src');
        }
      }

      function setModalActiveMedia(mediaId) {
        if (!dialog) return;

        let targetItem = dialog.querySelector(`[data-modal-media-item][data-media-id="${mediaId}"]`);
        if (!targetItem || targetItem.classList.contains('is-hidden')) {
          targetItem = dialog.querySelector('[data-modal-media-item]:not(.is-hidden)');
        }
        if (!targetItem) return;

        resetModalZoom();

        modalItems.forEach((item) => item.classList.remove('is-active'));
        targetItem.classList.add('is-active');

        modalThumbs.forEach((thumb) => thumb.classList.remove('is-active'));
        const activeThumb = dialog.querySelector(`[data-modal-thumb][data-media-id="${targetItem.dataset.mediaId}"]`);
        if (activeThumb && !activeThumb.classList.contains('is-hidden')) {
          activeThumb.classList.add('is-active');
        }

        const modalImg = targetItem.querySelector('img.product-modal__media-asset');

        loadModalImage(modalImg);

        if (modalImg && mediaMain) {
          const mainItem = mediaMain.querySelector(`[data-media-item][data-media-id="${targetItem.dataset.mediaId}"]`);
          const mainImg = mainItem ? mainItem.querySelector('img.product__media-asset') : null;
          if (mainImg) {
            const source = mainImg.currentSrc || mainImg.src;
            if (source && modalImg.src !== source) {
              modalImg.src = source;
            }
            if (mainImg.srcset && modalImg.srcset !== mainImg.srcset) {
              modalImg.srcset = mainImg.srcset;
            }
            if (mainImg.sizes && modalImg.sizes !== mainImg.sizes) {
              modalImg.sizes = mainImg.sizes;
            }
          }
        }

        if (modalImg) {
          modalImg.decoding = 'async';
          modalImg.fetchPriority = 'high';
          if (typeof modalImg.decode === 'function') {
            modalImg.decode().catch(() => {});
          }
        }
      }

      function resetModalZoom() {
        if (!dialog) return;
        modalZoomed = false;
        dialog.classList.remove('is-zoomed');
        dialog.style.setProperty('--modal-zoom-origin-x', '50%');
        dialog.style.setProperty('--modal-zoom-origin-y', '50%');
        resetModalTouchZoom();
      }

      function toggleModalZoom(event) {
        if (!dialog) return;
        const activeItem = dialog.querySelector('.product-modal__media-item.is-active');
        if (!activeItem) return;

        const img = activeItem.querySelector('img.product-modal__media-asset');
        if (!img) return;

        if (modalZoomed) {
          resetModalZoom();
          return;
        }

        const rect = img.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        if (
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom
        )
          return;
        const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
        const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));

        dialog.style.setProperty('--modal-zoom-origin-x', `${x}%`);
        dialog.style.setProperty('--modal-zoom-origin-y', `${y}%`);
        dialog.classList.add('is-zoomed');
        modalZoomed = true;
      }

      function syncModalForVariant(variant, preferredMediaId) {
        if (!dialog || !variant) return;

        const visibleMediaIds = getVariantMediaIds(variant);
        modalItems.forEach((item) => {
          const id = parseInt(item.dataset.mediaId, 10);
          const isVisible = visibleMediaIds.includes(id);
          item.classList.toggle('is-hidden', !isVisible);
          item.classList.remove('is-active');
        });

        modalThumbs.forEach((thumb) => {
          const id = parseInt(thumb.dataset.mediaId, 10);
          const isVisible = visibleMediaIds.includes(id);
          thumb.classList.toggle('is-hidden', !isVisible);
          thumb.classList.remove('is-active');
        });

        resetModalZoom();

        const featuredMediaId = variant.featured_media ? variant.featured_media.id : null;
        let nextActive = preferredMediaId || featuredMediaId;
        if (!nextActive && visibleMediaIds.length) nextActive = visibleMediaIds[0];
        if (nextActive) setModalActiveMedia(nextActive);
      }

      function openModal(preferredMediaId) {
        if (!dialog) return;
        const variant = getSelectedVariant();
        if (!variant) return;

        lastFocusedElement = document.activeElement;
        syncModalForVariant(variant, preferredMediaId);
        resetModalZoom();

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('product-modal-open');

        if (modalClose) modalClose.focus();
      }

      function closeModal() {
        if (!dialog) return;
        resetModalZoom();
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        document.documentElement.classList.remove('product-modal-open');

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
        lastFocusedElement = null;
      }

      function filterMediaByVariant(variant) {
        if (!variant) return;

        const visibleMediaIds = getVariantMediaIds(variant);
        const featuredMediaId = variant.featured_media ? variant.featured_media.id : null;

        mediaItems.forEach((item) => {
          const id = parseInt(item.dataset.mediaId, 10);
          const isVisible = visibleMediaIds.includes(id);
          item.classList.toggle('is-hidden', !isVisible);
          item.classList.remove('is-active');
        });

        mediaThumbs.forEach((thumb) => {
          const id = parseInt(thumb.dataset.mediaId, 10);
          const isVisible = visibleMediaIds.includes(id);
          thumb.classList.toggle('is-hidden', !isVisible);
          thumb.classList.remove('is-active');
        });

        let nextActive = featuredMediaId;
        if (!nextActive && visibleMediaIds.length) nextActive = visibleMediaIds[0];
        if (nextActive) setActiveMedia(nextActive);
        updateMediaIndicator();

        if (dialog && dialog.open) {
          syncModalForVariant(variant, nextActive);
        }
      }

      function findVariant() {
        if (!product.variants || !product.variants.length) return null;
        return product.variants.find((variant) => {
          return variant.options.every((value, index) => value === selectedOptions[index]);
        });
      }

      function getNotificationData(variant, prod) {
        prod = prod || product;

        if (!variant) {
          const variantIdFromInput = variantInput ? parseInt(variantInput.value, 10) : null;
          if (variantIdFromInput && product.variants) {
            variant = product.variants.find(function(v) { return v.id === variantIdFromInput; });
          }
        }

        if (!variant) {
          variant = findVariant();
        }

        if (!variant || !prod) return null;

        let variantTitle = '';
        if (prod.options && prod.options.length > 0) {
          if (!(prod.options.length === 1 && prod.options[0] === 'Title')) {
            variantTitle = variant.title || '';
          }
        }

        let productImage = '';
        if (variant.featured_image && variant.featured_image.src) {
          productImage = variant.featured_image.src.replace(/(\.[^.]+)$/, '_120x160_crop_center$1');
        } else if (prod.featured_image) {
          const imgSrc = typeof prod.featured_image === 'string' ? prod.featured_image : prod.featured_image.src;
          if (imgSrc) {
            productImage = imgSrc.replace(/(\.[^.]+)$/, '_120x160_crop_center$1');
          }
        }

        return {
          title: prod.title || '',
          variant: variantTitle,
          price: formatMoney(variant.price),
          image: productImage
        };
      }

      function setVariant(variant) {
        if (!variant) return;
        selectedOptions = [...variant.options];
        variantInput.value = variant.id;

        selectElements.forEach((select, index) => {
          select.value = variant.options[index];
        });

        swatchButtons.forEach((btn) => {
          const optionIndex = parseInt(btn.dataset.optionIndex, 10);
          const optionValue = btn.dataset.optionValue;
          btn.classList.toggle('is-active', variant.options[optionIndex] === optionValue);
        });

        optionButtons.forEach((btn) => {
          const optionIndex = parseInt(btn.dataset.optionIndex, 10);
          const optionValue = btn.dataset.optionValue;
          btn.classList.toggle('is-active', variant.options[optionIndex] === optionValue);
        });

        optionValueDisplays.forEach((display, index) => {
          display.textContent = variant.options[index];
        });

        updatePrice(variant);
        updateAvailability(variant);
        filterMediaByVariant(variant);

        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      function handleOptionChange(index, value) {
        selectedOptions[index] = value;
        const variant = findVariant();
        if (variant) {
          setVariant(variant);
        } else {
          addButton.disabled = true;
          addButton.classList.add('is-disabled');
          addButton.querySelector('span').textContent = section.dataset.unavailableText;
          if (availability) {
            availability.innerHTML = `<span class="status-dot status-dot--error"></span> ${section.dataset.unavailableText}`;
          }
          if (optionValueDisplays[index]) {
            optionValueDisplays[index].textContent = value;
          }
        }
      }

      function findVariantByOptions(options) {
        if (!product.variants || !product.variants.length) return null;
        return product.variants.find((variant) => {
          return variant.options.every((value, index) => value === options[index]);
        });
      }

      function getSelectedVariant() {
        if (variantInput && variantInput.value) {
          const variantId = parseInt(variantInput.value, 10);
          const match = product.variants ? product.variants.find((v) => v.id === variantId) : null;
          if (match) return match;
        }
        return findVariant() || product.selected_or_first_available_variant || null;
      }

      let hoverRestoreTimer = null;
      let hoverPreviewOptionIndex = null;

      function clearHoverRestoreTimer() {
        if (!hoverRestoreTimer) return;
        window.clearTimeout(hoverRestoreTimer);
        hoverRestoreTimer = null;
      }

      function restoreHoverPreview() {
        if (hoverPreviewOptionIndex === null) return;

        const selectedVariant = getSelectedVariant();
        if (selectedVariant && selectedVariant.options && optionValueDisplays[hoverPreviewOptionIndex]) {
          optionValueDisplays[hoverPreviewOptionIndex].textContent = selectedVariant.options[hoverPreviewOptionIndex];
        }

        if (selectedVariant) {
          filterMediaByVariant(selectedVariant);
        }

        hoverPreviewOptionIndex = null;
      }

      function scheduleHoverRestore() {
        clearHoverRestoreTimer();
        hoverRestoreTimer = window.setTimeout(() => {
          restoreHoverPreview();
        }, 60);
      }

      function previewVariantOnHover(optionIndex, optionValue) {
        if (!hoverQuery.matches) return;

        clearHoverRestoreTimer();

        const previewOptions = [...selectedOptions];
        previewOptions[optionIndex] = optionValue;

        let previewVariant = findVariantByOptions(previewOptions);
        if (!previewVariant && product.variants) {
          previewVariant =
            product.variants.find((v) => v.available && v.options && v.options[optionIndex] === optionValue) ||
            product.variants.find((v) => v.options && v.options[optionIndex] === optionValue) ||
            null;
        }

        if (!previewVariant) return;

        hoverPreviewOptionIndex = optionIndex;
        if (optionValueDisplays[optionIndex]) {
          optionValueDisplays[optionIndex].textContent = optionValue;
        }
        filterMediaByVariant(previewVariant);
      }

      function handleSwipe(endX, endY) {
        const deltaX = endX - swipeStartX;
        const deltaY = endY - swipeStartY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        swipeBlockedClick = true;
        window.setTimeout(() => {
          swipeBlockedClick = false;
        }, 300);
        if (deltaX < 0) {
          moveMedia(1);
        } else {
          moveMedia(-1);
        }
      }

      selectElements.forEach((select, index) => {
        select.addEventListener('change', (e) => {
          handleOptionChange(index, e.target.value);
        });
      });

      swatchButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const optionIndex = parseInt(btn.dataset.optionIndex, 10);
          const optionValue = btn.dataset.optionValue;
          handleOptionChange(optionIndex, optionValue);
        });
      });

      if (hoverQuery.matches) {
        swatchButtons.forEach((btn) => {
          btn.addEventListener('mouseenter', () => {
            const optionIndex = parseInt(btn.dataset.optionIndex, 10);
            const optionValue = btn.dataset.optionValue;
            previewVariantOnHover(optionIndex, optionValue);
          });
          btn.addEventListener('mouseleave', () => {
            scheduleHoverRestore();
          });
        });
      }

      optionButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const optionIndex = parseInt(btn.dataset.optionIndex, 10);
          const optionValue = btn.dataset.optionValue;
          handleOptionChange(optionIndex, optionValue);
        });
      });

      if (mediaMainWrap) {
        mediaMainWrap.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          if (event.target.closest('button, a, video, iframe, model-viewer')) return;
          swipeActive = true;
          swipeAxis = null;
          swipeStartX = event.touches[0].clientX;
          swipeStartY = event.touches[0].clientY;
        });

        mediaMainWrap.addEventListener(
          'touchmove',
          (event) => {
            if (!swipeActive || event.touches.length !== 1) return;
            const deltaX = event.touches[0].clientX - swipeStartX;
            const deltaY = event.touches[0].clientY - swipeStartY;
            if (!swipeAxis && (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8)) {
              swipeAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
            }
            if (swipeAxis === 'x') {
              event.preventDefault();
            }
          },
          { passive: false }
        );

        mediaMainWrap.addEventListener('touchend', (event) => {
          if (!swipeActive) return;
          swipeActive = false;
          if (swipeAxis !== 'x') return;
          if (!event.changedTouches || !event.changedTouches.length) return;
          handleSwipe(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
        });

        mediaMainWrap.addEventListener('touchcancel', () => {
          swipeActive = false;
          swipeAxis = null;
        });
      }

      mediaThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (thumb.classList.contains('is-hidden')) return;
          const target = parseInt(thumb.dataset.mediaId, 10);
          if (!Number.isFinite(target)) return;
          setActiveMedia(target);
          openModal(target);
        });

        if (hoverQuery.matches) {
          thumb.addEventListener('mouseenter', () => {
            if (thumb.classList.contains('is-hidden')) return;
            const target = parseInt(thumb.dataset.mediaId, 10);
            if (Number.isFinite(target)) setActiveMedia(target);
          });
        }
      });

      if (zoomEnabled && hoverQuery.matches && mediaMainWrap) {
        mediaMainWrap.style.setProperty('--zoom-scale', '1.65');

        mediaMainWrap.addEventListener('mousemove', (event) => {
          const rect = mediaMainWrap.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;
          mediaMainWrap.style.setProperty('--zoom-origin-x', `${x}%`);
          mediaMainWrap.style.setProperty('--zoom-origin-y', `${y}%`);
        });

        mediaMainWrap.addEventListener('mouseleave', () => {
          mediaMainWrap.style.setProperty('--zoom-origin-x', '50%');
          mediaMainWrap.style.setProperty('--zoom-origin-y', '50%');
        });
      }

      if (mediaMainWrap && dialog) {
        mediaMainWrap.addEventListener('click', (event) => {
          if (swipeBlockedClick) {
            swipeBlockedClick = false;
            return;
          }
          if (event.target.closest('video, iframe, model-viewer, button, a')) return;
          const mediaId = getActiveMediaId();
          if (mediaId) openModal(mediaId);
        });

        mediaMainWrap.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          const mediaId = getActiveMediaId();
          if (mediaId) openModal(mediaId);
        });
      }

      if (dialog) {
        if (modalClose) modalClose.addEventListener('click', () => closeModal());

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeModal();
        });

        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeModal();
        });

        if (modalViewer) {
          modalViewer.addEventListener('click', (event) => {
            if (!hoverQuery.matches) return;
            if (event.target.closest('button, a, video, iframe, model-viewer')) return;
            toggleModalZoom(event);
          });

          modalViewer.addEventListener('touchstart', (event) => {
            if (hoverQuery.matches) return;
            if (!event.touches || event.touches.length === 0) return;
            const img = getActiveModalImage();
            if (!img) return;
            if (event.touches.length === 2) {
              modalPinchActive = true;
              modalPanActive = false;
              modalTouchStartDistance = getTouchDistance(event.touches);
              modalTouchStartScale = modalTouchScale;
              modalTouchStartTranslateX = modalTouchTranslateX;
              modalTouchStartTranslateY = modalTouchTranslateY;
              const rect = img.getBoundingClientRect();
              const midX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
              const midY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
              const originX = Math.min(100, Math.max(0, ((midX - rect.left) / rect.width) * 100));
              const originY = Math.min(100, Math.max(0, ((midY - rect.top) / rect.height) * 100));
              img.style.transformOrigin = `${originX}% ${originY}%`;
            } else if (event.touches.length === 1 && modalTouchScale > 1) {
              modalPanActive = true;
              modalPinchActive = false;
              modalTouchStartX = event.touches[0].clientX;
              modalTouchStartY = event.touches[0].clientY;
              modalTouchStartTranslateX = modalTouchTranslateX;
              modalTouchStartTranslateY = modalTouchTranslateY;
            }
          });

          modalViewer.addEventListener(
            'touchmove',
            (event) => {
              if (hoverQuery.matches) return;
              const img = getActiveModalImage();
              if (!img) return;
              if (modalPinchActive && event.touches.length === 2) {
                event.preventDefault();
                const distance = getTouchDistance(event.touches);
                if (!modalTouchStartDistance) return;
                modalTouchScale = Math.min(3, Math.max(1, (distance / modalTouchStartDistance) * modalTouchStartScale));
                if (modalTouchScale === 1) {
                  modalTouchTranslateX = 0;
                  modalTouchTranslateY = 0;
                }
                const rect = img.getBoundingClientRect();
                const midX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
                const midY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
                const originX = Math.min(100, Math.max(0, ((midX - rect.left) / rect.width) * 100));
                const originY = Math.min(100, Math.max(0, ((midY - rect.top) / rect.height) * 100));
                img.style.transformOrigin = `${originX}% ${originY}%`;
                applyModalTouchTransform();
              } else if (modalPanActive && event.touches.length === 1 && modalTouchScale > 1) {
                event.preventDefault();
                const deltaX = event.touches[0].clientX - modalTouchStartX;
                const deltaY = event.touches[0].clientY - modalTouchStartY;
                modalTouchTranslateX = modalTouchStartTranslateX + deltaX;
                modalTouchTranslateY = modalTouchStartTranslateY + deltaY;
                applyModalTouchTransform();
              }
            },
            { passive: false }
          );

          modalViewer.addEventListener('touchend', (event) => {
            if (hoverQuery.matches) return;
            if (event.touches.length < 2) {
              modalPinchActive = false;
              modalTouchStartDistance = 0;
            }
            if (event.touches.length === 0) {
              modalPanActive = false;
              if (modalTouchScale <= 1) {
                resetModalTouchZoom();
              }
            }
          });

          modalViewer.addEventListener('touchcancel', () => {
            if (hoverQuery.matches) return;
            modalPinchActive = false;
            modalPanActive = false;
            if (modalTouchScale <= 1) {
              resetModalTouchZoom();
            }
          });
        }

        modalThumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            if (thumb.classList.contains('is-hidden')) return;
            const id = parseInt(thumb.dataset.mediaId, 10);
            if (!Number.isFinite(id)) return;
            setModalActiveMedia(id);
          });
        });
      }

      updateShorteningUI();
      if (shorteningLengthInput) {
        shorteningLengthInput.addEventListener('input', () => {
          shorteningLengthInput.setAttribute('aria-invalid', 'false');
        });
      }
      if (shorteningToggle && shorteningBody) {
        shorteningToggle.addEventListener('click', () => {
          const isEnabled = shorteningToggle.getAttribute('aria-checked') === 'true';
          shorteningToggle.setAttribute('aria-checked', String(!isEnabled));
          updateShorteningUI();
          if (!isEnabled && shorteningLengthInput) {
            shorteningLengthInput.focus();
          }
        });
      }

      function buildCartItem(formData) {
        const properties = {};
        let id = null;
        let quantity = 1;
        let sellingPlan = null;

        for (const [key, value] of formData.entries()) {
          if (key === 'id') {
            id = parseInt(value, 10);
            continue;
          }
          if (key === 'quantity') {
            quantity = parseInt(value, 10) || 1;
            continue;
          }
          if (key === 'selling_plan') {
            sellingPlan = value;
            continue;
          }
          if (key.startsWith('properties[') && key.endsWith(']')) {
            const propKey = key.slice(11, -1);
            if (propKey) properties[propKey] = value;
          }
        }

        const item = { id, quantity };
        if (Object.keys(properties).length) item.properties = properties;
        if (sellingPlan) item.selling_plan = sellingPlan;
        return item;
      }

      function appendCartItem(payload, index, item) {
        payload.append(`items[${index}][id]`, String(item.id));
        payload.append(`items[${index}][quantity]`, String(item.quantity || 1));
        if (item.selling_plan) {
          payload.append(`items[${index}][selling_plan]`, String(item.selling_plan));
        }
        if (item.properties) {
          Object.entries(item.properties).forEach(([key, value]) => {
            if (value === null || value === undefined) return;
            payload.append(`items[${index}][properties][${key}]`, String(value));
          });
        }
      }

      if (form) {
        form.addEventListener('submit', (event) => {
          if (!event.submitter || event.submitter.name === 'checkout') return;
          event.preventDefault();

          addButton.classList.add('is-loading');
          addButton.disabled = true;
          const addButtonLabel = addButton.querySelector('[data-add-to-cart-label]');
          if (addButtonLabel && section.dataset.addLoadingText) {
            addButtonLabel.textContent = section.dataset.addLoadingText;
          }

          const formData = new FormData(form);

          let shorteningLengthValue = '';
          if (shorteningLengthInput) {
            shorteningLengthValue = shorteningLengthInput.value ? shorteningLengthInput.value.trim() : '';
          }
          const shorteningEnabled = shorteningToggle
            ? shorteningToggle.getAttribute('aria-checked') === 'true'
            : shorteningLengthValue !== '';

          if (shorteningEnabled) {
            if (!shorteningLengthValue) {
              if (shorteningLengthInput) {
                shorteningLengthInput.setAttribute('aria-invalid', 'true');
                shorteningLengthInput.focus();
              }
              addButton.classList.remove('is-loading');
              addButton.disabled = false;
              status.textContent = shorteningError || section.dataset.addError;
              return;
            }

            if (!shorteningServiceVariantId || !Number.isFinite(shorteningServiceVariantId)) {
              addButton.classList.remove('is-loading');
              addButton.disabled = false;
              status.textContent = shorteningError || section.dataset.addError;
              return;
            }

            const linkId = `kz-${Date.now().toString(36)}-${Math.random().toString(16).slice(2, 8)}`;
            const lengthWithUnit = shorteningUnit
              ? `${shorteningLengthValue} ${shorteningUnit}`
              : shorteningLengthValue;
            const noteValue = shorteningNoteTemplate
              ? shorteningNoteTemplate.replace('__LENGTH__', lengthWithUnit)
              : lengthWithUnit;

            const mainItem = buildCartItem(formData);
            if (!mainItem.id || !Number.isFinite(mainItem.id)) {
              addButton.classList.remove('is-loading');
              addButton.disabled = false;
              status.textContent = section.dataset.addError;
              return;
            }

            if (!mainItem.properties) mainItem.properties = {};
            mainItem.properties[shorteningLinkKey] = linkId;
            if (shorteningNoteLabel) {
              mainItem.properties[shorteningNoteLabel] = noteValue;
              mainItem.properties[shorteningNoteKey] = shorteningNoteLabel;
            }

            const serviceItem = {
              id: shorteningServiceVariantId,
              quantity: mainItem.quantity,
              properties: {
                [shorteningLinkKey]: linkId,
                [shorteningServiceKey]: '1',
              },
            };

            const payload = new FormData();
            appendCartItem(payload, 0, mainItem);
            appendCartItem(payload, 1, serviceItem);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: payload,
            })
              .then((res) => {
                if (!res.ok) {
                  return res.json().then((error) => Promise.reject(error));
                }
                return res.json();
              })
              .then((data) => {
                addButton.classList.remove('is-loading');
                addButton.disabled = false;
                if (addButtonLabel && section.dataset.addToCartText) {
                  addButtonLabel.textContent = section.dataset.addToCartText;
                }
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
                const notificationData = getNotificationData();
                if (notificationData) {
                  document.dispatchEvent(
                    new CustomEvent('cart-notification:show', { detail: notificationData })
                  );
                }
                document.dispatchEvent(
                  new CustomEvent('dispatch:cart-drawer:refresh', {
                    detail: { open: false, opener: addButton }
                  })
                );
              })
              .catch((err) => {
              const message = err && err.description ? err.description : section.dataset.addError;
              console.error(err);
              addButton.classList.remove('is-loading');
              addButton.disabled = false;
              if (addButtonLabel && section.dataset.addToCartText) {
                addButtonLabel.textContent = section.dataset.addToCartText;
              }
              status.textContent = message;
              });
            return;
          }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          })
            .then((res) => res.json())
            .then((data) => {
              addButton.classList.remove('is-loading');
              addButton.disabled = false;
              if (addButtonLabel && section.dataset.addToCartText) {
                addButtonLabel.textContent = section.dataset.addToCartText;
              }

              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
              const notificationData2 = getNotificationData();
              console.log('Product page notification data:', notificationData2);
              if (notificationData2) {
                console.log('Dispatching cart-notification:show from product page');
                document.dispatchEvent(
                  new CustomEvent('cart-notification:show', { detail: notificationData2 })
                );
              } else {
                console.log('No notification data returned from getNotificationData()');
              }

              document.dispatchEvent(
                new CustomEvent('dispatch:cart-drawer:refresh', {
                  detail: { open: false, opener: addButton }
                })
              );
            })
            .catch((err) => {
              console.error(err);
              addButton.classList.remove('is-loading');
              addButton.disabled = false;
              if (addButtonLabel && section.dataset.addToCartText) {
                addButtonLabel.textContent = section.dataset.addToCartText;
              }
              status.textContent = section.dataset.addError;
            });
        });
      }

      const completeLook = section.querySelector('[data-complete-look]');
      if (completeLook) {
        const completeLookProductData = completeLook.querySelector('[data-complete-look-product-json]');
        const completeLookProduct = completeLookProductData ? JSON.parse(completeLookProductData.textContent) : null;
        const completeLookForm = completeLook.querySelector('[data-complete-look-form]');
        const variantHiddenInput = completeLook.querySelector('input[data-complete-look-variant-hidden]');
        const variantField = completeLook.querySelector('[data-complete-look-variant]');
        const priceCurrent = completeLook.querySelector('[data-complete-look-current]');
        const priceCompare = completeLook.querySelector('[data-complete-look-compare]');
        const addButton = completeLook.querySelector('[data-complete-look-submit]');
        const addLabel = completeLook.querySelector('[data-complete-look-label]');
        const status = completeLook.querySelector('[data-complete-look-status]');
        const completeLookImage = completeLook.querySelector('[data-complete-look-image]');

        const findCompleteLookVariant = (variantId) => {
          if (!completeLookProduct || !completeLookProduct.variants) return null;
          return completeLookProduct.variants.find((variant) => variant.id === variantId) || null;
        };

        const getImageUrl = (image, width) => {
          if (!image || !image.src) return null;
          // Shopify CDN URL pattern: replace width parameter
          const url = image.src;
          return url.replace(/(_\d+x\d*)|(\.jpg)|(\.png)|(\.webp)/i, (match, size, jpg, png, webp) => {
            if (size) return `_${width}x`;
            return match;
          }).replace(/width=\d+/, `width=${width}`);
        };

        const updateCompleteLookImage = (variant) => {
          if (!completeLookImage) return;
          
          // Use variant's featured_image or fall back to product's featured_image
          const image = variant?.featured_image || completeLookProduct?.featured_image;
          if (!image || !image.src) return;
          
          // Build new srcset and src
          const widths = [120, 240, 360, 500];
          const srcset = widths.map(w => {
            const url = image.src.replace(/(&width=)\d+/, `$1${w}`);
            // Handle Shopify CDN URLs
            let finalUrl = url;
            if (url.includes('shopify.com')) {
              finalUrl = url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, (match, ext, format, query) => {
                const params = query ? query + '&width=' + w : '?width=' + w;
                return ext + params;
              });
              // If the URL already has width parameter, just update it
              if (finalUrl.includes('width=')) {
                finalUrl = finalUrl.replace(/width=\d+/, `width=${w}`);
              }
            }
            return `${finalUrl} ${w}w`;
          }).join(', ');
          
          // Set the main src (use 500w as default)
          let mainSrc = image.src;
          if (mainSrc.includes('shopify.com') && !mainSrc.includes('width=')) {
            mainSrc = mainSrc + (mainSrc.includes('?') ? '&' : '?') + 'width=500';
          } else if (mainSrc.includes('width=')) {
            mainSrc = mainSrc.replace(/width=\d+/, 'width=500');
          }
          
          completeLookImage.src = mainSrc;
          completeLookImage.srcset = srcset;
          completeLookImage.alt = image.alt || completeLookProduct?.title || '';
        };

        const updateCompleteLook = (variant) => {
          if (!variant) return;
          if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
          if (priceCompare) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              priceCompare.textContent = formatMoney(variant.compare_at_price);
              priceCompare.hidden = false;
            } else {
              priceCompare.textContent = '';
              priceCompare.hidden = true;
            }
          }
          if (addButton) {
            if (variant.available) {
              addButton.disabled = false;
              addButton.classList.remove('is-disabled');
            } else {
              addButton.disabled = true;
              addButton.classList.add('is-disabled');
            }
          }
          // Update the image based on variant's featured_image
          updateCompleteLookImage(variant);
        };

        if (variantField && completeLookProduct) {
          const initialId = parseInt(variantField.value, 10);
          updateCompleteLook(findCompleteLookVariant(initialId));
          if (variantHiddenInput) {
            variantHiddenInput.value = initialId;
          }
          if (variantField.tagName === 'SELECT') {
            variantField.addEventListener('change', (event) => {
              const nextId = parseInt(event.target.value, 10);
              if (variantHiddenInput) {
                variantHiddenInput.value = nextId;
              }
              updateCompleteLook(findCompleteLookVariant(nextId));
            });
          }
        }

        if (completeLookForm && addButton) {
          completeLookForm.addEventListener('submit', (event) => {
            event.preventDefault();

            addButton.classList.add('is-loading');
            addButton.classList.remove('is-success');
            addButton.disabled = true;
            if (status) status.textContent = '';

            const formData = new FormData(completeLookForm);
            const hiddenVariantInput = completeLookForm.querySelector('input[name="id"]');
            const currentVariantId = hiddenVariantInput ? parseInt(hiddenVariantInput.value, 10) : null;
            const currentVariant = Number.isFinite(currentVariantId)
              ? findCompleteLookVariant(currentVariantId)
              : null;

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: formData,
            })
              .then((res) => {
                if (!res.ok) {
                  return res.json().then((error) => Promise.reject(error));
                }
                return res.json();
              })
              .then((data) => {
                addButton.classList.remove('is-loading');
                addButton.classList.add('is-success');
                if (currentVariant) {
                  updateCompleteLook(currentVariant);
                } else {
                  addButton.disabled = false;
                }
                setTimeout(() => {
                  addButton.classList.remove('is-success');
                }, 1500);
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
                const completeLookNotification = getNotificationData(currentVariant, completeLookProduct);
                if (completeLookNotification) {
                  document.dispatchEvent(
                    new CustomEvent('cart-notification:show', { detail: completeLookNotification })
                  );
                }
                document.dispatchEvent(
                  new CustomEvent('dispatch:cart-drawer:refresh', {
                    detail: { open: false, opener: addButton }
                  })
                );
              })
              .catch((err) => {
                const message = err && err.description ? err.description : section.dataset.addError;
                addButton.classList.remove('is-loading');
                addButton.classList.remove('is-success');
                if (currentVariant) {
                  updateCompleteLook(currentVariant);
                } else {
                  addButton.disabled = false;
                }
                if (status) status.textContent = message;
              });
          });
        }
      }

      section.querySelectorAll('[data-show-more]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const container = btn.closest('.product__variant-swatches, .product__option-buttons');
          if (container) {
            container.querySelectorAll('.is-hidden-initially').forEach((el) => {
              el.classList.remove('is-hidden-initially');
            });
            updateScrollHint(container);
            btn.remove();
          }
        });
      });

      if (isCurrentDiscountStored()) {
        applyProductDiscountState();
      }

      if (discountNotice && productDiscountCode) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then((response) => response.json())
          .then((cart) => {
            if (cartHasCurrentDiscount(cart)) {
              setStoredDiscountCode(productDiscountCode);
              applyProductDiscountState();
            } else if (cartHasAnyDiscount(cart) && (productDiscountApplied || isCurrentDiscountStored())) {
              clearProductDiscountState();
            }
          })
          .catch(() => {});
      }

      document.addEventListener('discount:removed', (event) => {
        const removedCode = event.detail && event.detail.code ? event.detail.code : '';
        if (!removedCode || normalizeDiscountCode(removedCode) === normalizeDiscountCode(productDiscountCode)) {
          clearProductDiscountState();
        }
      });

      if (product.selected_or_first_available_variant) {
        setVariant(product.selected_or_first_available_variant);
      } else {
        updateMediaIndicator();
      }
      window.requestAnimationFrame(() => {
        updateMediaIndicator();
        updateAllScrollHints();
      });

      scrollHintContainers.forEach((container) => {
        updateScrollHint(container);
        container.addEventListener('scroll', () => updateScrollHint(container), { passive: true });
      });

      window.addEventListener('resize', updateAllScrollHints);

      if (discountNotice) {
        const applyButton = discountNotice.querySelector('[data-apply-discount]');
        const applyLabel = discountNotice.querySelector('[data-apply-discount-label]');
        const status = discountNotice.querySelector('[data-discount-status]');
        const applyingLabel = discountNotice.dataset.applyingLabel;
        const applyError = discountNotice.dataset.applyError;
        const defaultLabel = applyLabel ? applyLabel.textContent : '';

        const setStatus = (message, isSuccess) => {
          if (status) {
            status.textContent = message || '';
            status.classList.toggle('is-error', !isSuccess);
          }
        };

        if (applyButton) {
          applyButton.addEventListener('click', async () => {
            if (!productDiscountCode) return;
            applyButton.disabled = true;
            applyButton.setAttribute('aria-busy', 'true');
            if (applyLabel && applyingLabel) applyLabel.textContent = applyingLabel;
            setStatus(applyingLabel, true);

            try {
              const response = await fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify({ discount: productDiscountCode })
              });
              const cart = await response.json();
              if (!response.ok) {
                throw new Error('Discount code request failed.');
              }
              if (cart && cart.item_count > 0 && !cartHasCurrentDiscount(cart)) {
                throw new Error('Discount code was not applied.');
              }
              setStoredDiscountCode(productDiscountCode);
              applyProductDiscountState();
            } catch (err) {
              applyButton.disabled = false;
              applyButton.removeAttribute('aria-busy');
              if (applyLabel) applyLabel.textContent = defaultLabel;
              setStatus(applyError, false);
            }
          });
        }
      }

      // Related Products
      const relatedContainer = section.querySelector('[data-related-products]');
      if (relatedContainer) {
        const productId = relatedContainer.dataset.productId;
        const limit = parseInt(relatedContainer.dataset.limit, 10) || 8;
        const grid = relatedContainer.querySelector('[data-related-grid]');

        if (productId && grid) {
          const recommendationsUrl = `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=related`;

          fetch(recommendationsUrl)
            .then((res) => res.json())
            .then((data) => {
              grid.classList.add('is-loaded');

              if (!data.products || data.products.length === 0) {
                relatedContainer.style.display = 'none';
                return;
              }

              const fragment = document.createDocumentFragment();
              data.products.forEach((prod, index) => {
                const card = createProductCard(prod, index);
                if (card) fragment.appendChild(card);
              });
              grid.appendChild(fragment);

              // Make animated items visible immediately (they bypass IntersectionObserver)
              grid.querySelectorAll('.anim-stagger-item, .anim-fade-in').forEach(el => {
                el.classList.add('is-visible');
              });
            })
            .catch((err) => {
              console.error('Failed to load related products:', err);
              grid.classList.add('is-loaded');
              relatedContainer.style.display = 'none';
            });
        }
      }

      function createProductCard(prod, index) {
        const card = document.createElement('article');
        card.className = 'product-card anim-stagger-item';
        card.dataset.productCard = '';
        card.style.setProperty('--stagger-index', index);

        const variant = prod.variants && prod.variants[0] ? prod.variants[0] : null;
        const price = variant ? variant.price : prod.price;
        const compareAtPrice = variant ? variant.compare_at_price : prod.compare_at_price;
        const available = prod.available !== false;

        const onSale = compareAtPrice && compareAtPrice > price;
        const discountPercent = onSale ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100) : 0;

        if (!available) card.classList.add('is-sold-out');

        // Build image URL using Shopify CDN format
        let imageUrl = null;
        if (prod.featured_image) {
          // Handle both old format and new Shopify CDN format
          let baseUrl = prod.featured_image;
          // Remove existing size parameters if present
          baseUrl = baseUrl.replace(/_\d+x\d*[^.]*/, '');
          // Add width parameter for Shopify CDN
          if (baseUrl.includes('cdn.shopify.com')) {
            imageUrl = baseUrl.includes('?')
              ? baseUrl + '&width=600'
              : baseUrl + '?width=600';
          } else {
            imageUrl = baseUrl;
          }
        }

        const priceFormatted = formatMoney(price);
        const compareFormatted = onSale ? formatMoney(compareAtPrice) : '';

        let badgeHtml = '';
        if (!available) {
          badgeHtml = `<span class="product-card__badge product-card__badge--sold-out">${section.dataset.unavailableText || 'Ausverkauft'}</span>`;
        } else if (onSale && discountPercent > 0) {
          badgeHtml = `<span class="product-card__badge product-card__badge--sale">Spare ${discountPercent}%</span>`;
        }

        let priceHtml = '';
        if (onSale) {
          priceHtml = `
            <s class="product-card__price-compare">${compareFormatted}</s>
            <span class="product-card__price-sale">${priceFormatted}</span>
          `;
        } else {
          priceHtml = `<span class="product-card__price-regular">${priceFormatted}</span>`;
        }

        const escapedTitle = prod.title.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

        card.innerHTML = `
          <div class="product-card__media-wrap">
            <a class="product-card__media-link" href="${prod.url}">
              <div class="product-card__media">
                ${imageUrl ? `<img src="${imageUrl}" alt="${escapedTitle}" class="product-card__image product-card__image--primary" loading="lazy" decoding="async">` : '<div class="product-card__placeholder"></div>'}
                <div class="product-card__badges" aria-hidden="true">${badgeHtml}</div>
              </div>
            </a>
          </div>
          <div class="product-card__info">
            <div class="product-card__meta">
              <h3 class="product-card__title">
                <a class="product-card__title-link" href="${prod.url}">${escapedTitle.toUpperCase()}</a>
              </h3>
              <div class="product-card__price">${priceHtml}</div>
            </div>
          </div>
        `;

        return card;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  // Close dropdowns when clicking outside
  document.addEventListener('click', (event) => {
    const details = document.querySelectorAll('details.search__filter-dropdown');
    details.forEach((detail) => {
      if (detail.hasAttribute('open') && !detail.contains(event.target)) {
        detail.removeAttribute('open');
      }
    });
  });

  // Reveal animation for search results - all items animate on page load
  const searchSection = document.querySelector('.search');
  if (searchSection) {
    const revealItems = searchSection.querySelectorAll('[data-search-item]');
    if (revealItems.length > 0) {
      searchSection.classList.add('is-ready');
      // Animate all items immediately with staggered delay
      requestAnimationFrame(() => {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      if (section.dataset.stlInit === 'true') return;
      section.dataset.stlInit = 'true';

      const scrollTrack = section.querySelector('[data-scroll-track]');
      const looks = Array.from(section.querySelectorAll('.stl__look[data-look]'));
      const counterCurrent = section.querySelector('[data-current]');
      const bars = Array.from(section.querySelectorAll('[data-goto]'));
      const prevBtn = section.querySelector('[data-prev]');
      const nextBtn = section.querySelector('[data-next]');
      const moneyFormat = section.dataset.moneyFormat || '';

      let currentLookIndex = 0;

      function formatMoney(cents) {
        if (window.Shopify && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, window.Shopify.money_format || moneyFormat);
        }
        const amount = (cents / 100).toFixed(2).replace('.', ',');
        if (moneyFormat) {
          return moneyFormat.replace(/\{\{\s*amount[^{}]*\}\}/, amount);
        }
        return amount;
      }

      function updateCartCount(cart) {
        const count = document.querySelector('.header__cart-count');
        if (count) {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        }
      }

      function addToCart(variantId, button) {
        if (!variantId || button.classList.contains('is-loading')) return;

        button.classList.add('is-loading');
        button.disabled = true;

        const addUrl = window.Shopify?.routes?.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js';

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then((res) => res.ok ? res.json() : Promise.reject(res))
          .then(() => fetch('/cart.js'))
          .then((res) => res.json())
          .then((cart) => {
            button.classList.remove('is-loading');
            button.classList.add('is-success');
            button.disabled = false;
            updateCartCount(cart);

            document.dispatchEvent(
              new CustomEvent('dispatch:cart-drawer:refresh', {
                detail: { open: false, cart, opener: button }
              })
            );

            setTimeout(() => {
              button.classList.remove('is-success');
            }, 1500);
          })
          .catch(() => {
            button.classList.remove('is-loading');
            button.disabled = false;
          });
      }

      function updateNav() {
        if (counterCurrent) counterCurrent.textContent = currentLookIndex + 1;
        bars.forEach((bar, i) => bar.classList.toggle('is-active', i === currentLookIndex));
        if (prevBtn) prevBtn.disabled = currentLookIndex === 0;
        if (nextBtn) nextBtn.disabled = currentLookIndex === looks.length - 1;
      }

      function goToLook(index) {
        const target = looks[Math.max(0, Math.min(index, looks.length - 1))];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      }

      function handleScroll() {
        if (!scrollTrack || looks.length === 0) return;

        const trackRect = scrollTrack.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        looks.forEach((look, i) => {
          const lookRect = look.getBoundingClientRect();
          const lookCenter = lookRect.left + lookRect.width / 2;
          const distance = Math.abs(lookCenter - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
          }
        });

        if (closestIndex !== currentLookIndex) {
          currentLookIndex = closestIndex;
          updateNav();
        }
      }

      if (scrollTrack && looks.length > 1) {
        let scrollTimeout;
        scrollTrack.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(handleScroll, 50);
        }, { passive: true });
      }

      bars.forEach((bar) => {
        bar.addEventListener('click', () => goToLook(parseInt(bar.dataset.goto, 10)));
      });
      if (prevBtn) prevBtn.addEventListener('click', () => goToLook(currentLookIndex - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goToLook(currentLookIndex + 1));

      looks.forEach((look) => {
        const hotspots = Array.from(look.querySelectorAll('[data-hotspot]'));
        const products = Array.from(look.querySelectorAll('[data-product]'));
        const addAllBtn = look.querySelector('[data-add-all]');
        const totalEl = look.querySelector('[data-look-total]');
        let highlightTimeout;

        function updateLookTotal() {
          if (!totalEl) return;
          let total = 0;
          products.forEach((product) => {
            if (product.dataset.available === 'true') {
              total += parseInt(product.dataset.priceCents, 10) || 0;
            }
          });
          totalEl.textContent = formatMoney(total);
        }

        function highlightProduct(index, scrollTo) {
          products.forEach((p, i) => p.classList.toggle('is-highlight', i === index));
          hotspots.forEach((h, i) => h.classList.toggle('is-active', i === index));

          const targetProduct = products[index];
          if (targetProduct && scrollTo) {
            targetProduct.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }

          clearTimeout(highlightTimeout);
          highlightTimeout = setTimeout(() => {
            products.forEach((p) => p.classList.remove('is-highlight'));
            hotspots.forEach((h) => h.classList.remove('is-active'));
          }, 2600);
        }

        hotspots.forEach((hotspot) => {
          hotspot.addEventListener('click', () => {
            highlightProduct(parseInt(hotspot.dataset.index, 10), true);
          });
        });

        products.forEach((product) => {
          const variantSelect = product.querySelector('[data-variant-select]');
          const addBtn = product.querySelector('[data-add-btn]');
          const priceEl = product.querySelector('[data-price]');
          const compareEl = product.querySelector('[data-compare-price]');
          const imgEl = product.querySelector('[data-product-img]');

          if (variantSelect) {
            variantSelect.addEventListener('change', () => {
              const option = variantSelect.options[variantSelect.selectedIndex];
              const price = parseInt(option.dataset.price, 10);
              const compare = parseInt(option.dataset.compare, 10) || 0;
              const available = option.dataset.available === 'true';
              const imgUrl = option.dataset.img;

              product.dataset.priceCents = price;
              product.dataset.available = available;

              if (priceEl) priceEl.textContent = formatMoney(price);
              if (compareEl) {
                if (compare > price) {
                  compareEl.textContent = formatMoney(compare);
                  compareEl.hidden = false;
                } else {
                  compareEl.hidden = true;
                }
              }

              if (addBtn) {
                addBtn.dataset.variantId = option.value;
                addBtn.disabled = !available;
                addBtn.classList.toggle('is-disabled', !available);
              }

              if (imgEl) {
                const defaultImg = imgEl.dataset.defaultImg;
                imgEl.src = imgUrl || defaultImg || imgEl.src;
              }

              updateLookTotal();
            });
          }

          if (addBtn) {
            addBtn.addEventListener('click', () => {
              addToCart(addBtn.dataset.variantId, addBtn);
            });
          }

          product.addEventListener('mouseenter', () => {
            const index = parseInt(product.dataset.index, 10);
            hotspots.forEach((h, i) => h.classList.toggle('is-active', i === index));
          });

          product.addEventListener('mouseleave', () => {
            hotspots.forEach((h) => h.classList.remove('is-active'));
          });
        });

        if (addAllBtn) {
          addAllBtn.addEventListener('click', () => {
            if (addAllBtn.classList.contains('is-loading')) return;

            const items = [];
            products.forEach((product) => {
              const addBtn = product.querySelector('[data-add-btn]');
              if (addBtn && !addBtn.disabled) {
                items.push({
                  id: parseInt(addBtn.dataset.variantId, 10),
                  quantity: 1
                });
              }
            });

            if (items.length === 0) return;

            addAllBtn.classList.add('is-loading');

            const addUrl = window.Shopify?.routes?.root
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js';

            fetch(addUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ items })
            })
              .then((res) => res.ok ? res.json() : Promise.reject(res))
              .then(() => fetch('/cart.js'))
              .then((res) => res.json())
              .then((cart) => {
                addAllBtn.classList.remove('is-loading');
                updateCartCount(cart);

                const textEl = addAllBtn.querySelector('[data-add-all-text]');
                const originalText = textEl?.textContent;
                const addedText = addAllBtn.dataset.addedText;
                if (textEl && addedText) textEl.textContent = addedText;

                document.dispatchEvent(
                  new CustomEvent('dispatch:cart-drawer:refresh', {
                    detail: { open: true, cart, opener: addAllBtn }
                  })
                );

                setTimeout(() => {
                  if (textEl && originalText) textEl.textContent = originalText;
                }, 2000);
              })
              .catch(() => {
                addAllBtn.classList.remove('is-loading');
              });
          });
        }
      });

      updateNav();
    };

    const observeSection = (section) => {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
              initSection(section);
            }
          });
        }, { rootMargin: '300px 0px' });
        observer.observe(section);
      } else {
        initSection(section);
      }
    };

    document.querySelectorAll('[data-stl]').forEach(observeSection);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-stl]').forEach(observeSection);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
